<template>
  <div class="adminInfo">
    <div style="position:fixed;width:100%;">
      <wv-search-bar
        :autofocus="false"
        v-model="value"
        @search="onSearch"
        @cancel="onCancel"
        placeholder="请输入搜索的内容"
      />
      <mt-navbar v-model="selected" style="border-bottom:1px solid lightgray;">
        <mt-tab-item @click.native="unCensorPost()" id="1" style="border-right:1px solid lightgray;">未审核帖子ˇ</mt-tab-item>
        <mt-tab-item @click.native="censorPost()" id="2" style="border-right:1px solid lightgray;">已审核帖子ˇ</mt-tab-item>
       <!-- <mt-tab-item @click.native="logout()" id="3">退出</mt-tab-item>-->
      </mt-navbar>

    </div>
    <wv-tabbar :fixed="true">
      <wv-tabbar-item to="/" is-on>
        <span slot="icon" style="display: inline-block; position: relative;">
          <img class="weui-tabbar__icon" src="../assets/eye.png" slot="icon">
        </span>
        发现
      </wv-tabbar-item>

      <wv-tabbar-item >
        <img class="weui-tabbar__icon" src="../assets/logout.png" slot="icon"  @click="logout()"> 退出
      </wv-tabbar-item>
    </wv-tabbar>
  <!--  未审核帖子  -->
    <div>
      <van-popup v-model="showunCensorPost" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnType"
          @cancel="cancelunCensorPost"
          @confirm="confirmunCensorPost"
        />
      </van-popup>
    </div>
    <!--已审核帖子-->
    <div>
      <van-popup v-model="showcensorPost" position="bottom">
        <van-picker
          show-toolbar
          :columns="columnType"
          @cancel="cancelcensorPost"
          @confirm="confirmcensorPost"
        />
      </van-popup>
    </div>


    <div>
      <div style="width:100%;height:77px;"></div>
      <adminInfoView ref="adminInfoView"></adminInfoView>
    </div>

  </div>

</template>

<script>
  import {getByLikeContent,getServiceType,getUnCensorPost,OK,HOST} from '../api/data.js'
  import adminInfoView from './adminInfoView'
  import 'vant/lib/index.css';
  import { Picker } from 'vant';
  import { Popup } from 'vant';
  import Vue from 'vue'
  Vue.use(Popup);
  Vue.use(Picker);

  export default {
    data() {
      return {
        inputShowed: false,
        inputVal: "",
        selected:"1",
        value: '',
        pid:"0",
        showunCensorPost: false,
        showcensorPost: false,
        showDefault:false,
        columnType: ['全部', '投诉', '建议', '咨询', '表扬'],
      }
    },
    //页面加载调用
    mounted() {

    },
    computed:{
    },
    /*beforeCreate: function () {
      let ticket = decodeURIComponent((new RegExp('[?|&]' +  'ticket' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
      console.log("beforeCreate ticket:"+ticket);
      if(ticket!=null){
        this.roleType= this.$store.state.roleType;
        console.log(" this.roleType:"+ this.roleType);
        if(this.roleType==='1'){
          window.location.href = '/#/adminCasLogin'
        }

      }

    },*/
    methods: {
      //点击退出清除用户的cookie数据以及跳转到首页
      logout(){
        //退出清除用户的cookie数据
        //清除cookie

        var that = this
        that.$Cookies.remove('userName');
        that.$Cookies.remove('password');
        //删除所有
        window.localStorage.clear();
      /*  window.localStorage.removeItem('Flag');  //清除文件
        window.localStorage.removeItem('operator');  //清除文件
        window.localStorage.removeItem('adminId');  //清除文件
        window.localStorage.removeItem('usertype');  //清除文件
        window.localStorage.removeItem('adminName');  //清除文件
        window.localStorage.removeItem('telPhone');  //清除文件*/

  /*      this.$router.push({
          path: '/'
        })*/
        window.location.href = "/";
      },

      //未审核的帖子
      unCensorPost () {
        this.toShowunCensorPost();
        this.closecensorPost()
      },
      //审核的帖子
      censorPost () {
        this.toShowcensorPost();
        this.closeunCensorPost()
      },

      onSearch (value) {
        // 根据内容关键字搜索
        this.$refs.adminInfoView.getByLikeTitleOrContent(value); //调用子组件的方法


      },
      onCancel () {
        // 自定义取消事件处理
      },
      confirmunCensorPost(value, index) {
        this.showunCensorPost = false;
        this.$refs.adminInfoView.getUnCensorPost(index);

      },
      cancelunCensorPost(value, index){
        this.showunCensorPost = false;
      },
      closeunCensorPost() {
        this.showunCensorPost = false
      },
      toShowunCensorPost() {
        this.showunCensorPost = true
      },

      confirmcensorPost(value, index) {
        //this.value = value;
        this.showcensorPost = false;
        this.$refs.adminInfoView.getServiceType(index);

      },
      cancelcensorPost(value, index){
        this.showcensorPost = false;
      },
      closecensorPost() {
        this.showcensorPost = false
      },
      toShowcensorPost() {
        this.showcensorPost = true
      },

    },
    components:{
      adminInfoView

    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/baseScss.scss";
  .adminInfo{
    .mint-navbar{
      a{
        .mint-tab-item-label{
        }

      }

      .mint-tab-item{
        padding:10px 0;
      }
      .mint-tab-item-label{
        font-size: 14px;
        border-right: solid 1px $cl9;
      }
    }
    .mint-tab-item.is-selected{
      border:none;
    }
    .is-selected{
      margin-bottom: 0px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/adminIndex.vue